import { render, staticRenderFns } from "./BoxSingle.vue?vue&type=template&id=02a9bea0&"
import script from "./BoxSingle.vue?vue&type=script&lang=js&"
export * from "./BoxSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports